module.exports = "figcaption {\r\n  text-align: center;\r\n}\r\nimg:hover{\r\n  border-color:red;\r\n  border-style:dashed;\r\n}\r\n\r\n"